import { useEffect } from 'react'
import styles from './MarkPanel.module.css'
import { useDispatch, useSelector } from 'react-redux'
import { getGradeWeight } from '../../../actions/directory'

const MarkPanel = ({ cellChanging, handleOpenComment, student, gradeValue, setSelected, selected, classbook, setPanelOpen, onColumnSelected }) => {

    const dispatch = useDispatch()
    const { gradeWeight } = useSelector(state => state.directory)

    useEffect(() => {
        dispatch(getGradeWeight())
    }, [])

    const handleSetColumn = (lessonid) => {
        const arr = classbook.filter((el) => el.lessonid == lessonid).map((el) => ({ mid: el.mid, lessonid: el.lessonid }));
        const isDeselect = (arr.length === selected.length) && selected.length > 0 && (arr[0]?.mid === selected[0]?.mid);
        if (isDeselect) {
            setSelected([]);
        } else {
            setSelected(arr);
            setPanelOpen({ mid: null, lessonid: null });
            onColumnSelected?.();
        }
    }

    const weights = Array.isArray(gradeWeight) ? gradeWeight : []

    return (
        <div className={styles.markPanel}>
            {(Array.isArray(gradeValue) ? gradeValue : []).map((el, i) => (
                <div
                    className={styles.markPanelItem}
                    key={i}
                    onClick={() => cellChanging('grade', el.value)}
                >
                    {el.value}
                </div>
            ))}

            <div className={styles.markPanelItemBottom}>
                <div
                    className={styles.markPanelItem}
                    onClick={() => cellChanging('grade', null)}
                >
                    Удалить оценки
                </div>
                <div
                    className={styles.markPanelItem}
                    onClick={() => handleOpenComment({ mid: student.mid, lessonid: student.lessonid, student })}
                >
                    Комментарий
                </div>
                <div className={`${styles.markPanelItem} ${styles.markPanelItemSelect}`}>
                    Вес оценки
                    <div className={styles.markPanelSelectWrapper}>
                        {weights.map(el => (
                            <div
                                key={el.weight}
                                className={styles.markPanelSelectItem}
                                onClick={() => cellChanging('gradeweight', el.weight)}
                            >
                                {student.gradeweight == el.weight ? '+' : ''}{el.weight}
                            </div>
                        ))}
                    </div>
                </div>
                <div className={styles.markPanelItem} onClick={() => handleSetColumn(student.lessonid)}>
                    Отметить колонку
                </div>
            </div>
        </div>
    )
}

export default MarkPanel
